
export class NoteUpd
{ 
    noteId: any;
    notes: string = "";
    isPrintable: boolean = false;
}
